// Utility functions for Medical History
// These are minimal implementations to maintain compatibility with existing code
import { getMedicalHistory } from '../api/api'

export const getMedHistProgress = (data) => {
  if (!data) return '0'

  const medHistSections = [
    { key: 'allergies' },
    { key: 'chronicIllnesses' },
    { key: 'meds' },
    { key: 'covidInfo' },
    { key: 'familyHistory' },
    { key: 'lifestyle' },
    { key: 'mentalHealth' },
    { key: 'surgicalHistory' }
  ]

  const totalFields = medHistSections.length
  let completedFields = 0

  medHistSections.forEach((section) => {
    const { key } = section
    if (data[key] && data[key].updatedAt) {
      completedFields++
    }
  })

  return Math.round((completedFields / totalFields) * 100).toString()
}

export const getPatient = async (userRef) => {
  try {
    const medicalHistoryData = await getMedicalHistory(userRef)
    // The API returns the medical history record directly
    // We need to structure it to match what the components expect
    return {
      userRef: userRef,
      medicalHistory: medicalHistoryData?.data || medicalHistoryData?.medicalHistory || medicalHistoryData,
      ...medicalHistoryData // Include all other fields from the medical history record
    }
  } catch (error) {
    console.error('Error fetching patient medical history:', error)
    return {
      userRef: userRef,
      medicalHistory: null
    }
  }
}

export const updatePatient = async (patientData) => {
  // This function would need to be implemented based on your API requirements
  console.warn('updatePatient function needs to be implemented for your specific API')
  return patientData
}

export const getPatientPwa = async (userRef) => {
  try {
    const medicalHistoryData = await getMedicalHistory(userRef)
    // The API returns the medical history record directly
    // We need to structure it to match what the components expect
    return {
      userRef: userRef,
      medicalHistory: medicalHistoryData?.data || medicalHistoryData?.medicalHistory || medicalHistoryData,
      ...medicalHistoryData // Include all other fields from the medical history record
    }
  } catch (error) {
    console.error('Error fetching patient medical history for PWA:', error)
    return {
      userRef: userRef,
      medicalHistory: null
    }
  }
}
